import { PATHS } from './paths';
import { hasValidAuthToken } from './loaders/authLoader';
import { decodeJwtPayload, parseAuToken } from '../utils/oidcTokenStorage';
import { showSigningOut as showOverlay, hideSigningOut as hideOverlay } from './signingOutOverlay';

const PUBLIC_PATHS = [PATHS.ROOT, PATHS.LOGOUT, PATHS.UNAUTH_LOGOUT, PATHS.SIGNED_OUT];
const ANONYMOUS_SESSION = 'session';

let sessionFingerprint = null;
let overlayEscapeTimeoutId = null;

const OVERLAY_ESCAPE_MS = 6000;

const currentUserId = () => {
    const accessToken = parseAuToken()?.access_token;
    return decodeJwtPayload(accessToken)?.sub || null;
};

const currentFingerprint = () => (
    hasValidAuthToken() ? (currentUserId() || ANONYMOUS_SESSION) : null
);

const isSessionStale = () => {
    const current = currentFingerprint();
    if (!current) return true;
    if (!sessionFingerprint) sessionFingerprint = current;
    return current !== sessionFingerprint;
};

const isPublicPath = () => PUBLIC_PATHS.includes(window.location.pathname);

const showSigningOut = () => {
    if (overlayEscapeTimeoutId) return;
    showOverlay();
    overlayEscapeTimeoutId = window.setTimeout(attemptEscapeReload, OVERLAY_ESCAPE_MS);
};

const attemptEscapeReload = () => {
    if (navigator.onLine) {
        window.location.reload();
        return;
    }
    window.addEventListener('online', () => window.location.reload(), { once: true });
};

const hideSigningOut = () => {
    if (overlayEscapeTimeoutId) {
        clearTimeout(overlayEscapeTimeoutId);
        overlayEscapeTimeoutId = null;
    }
    hideOverlay();
};

export const handlePageHide = (event) => {
    if (!event.persisted) return;
    if (!hasValidAuthToken()) showSigningOut();
};

export const handlePageShow = (event) => {
    if (!event.persisted) return;
    if (isPublicPath() || !isSessionStale()) {
        hideSigningOut();
        return;
    }
    window.location.reload();
};

export const handleVisibilityChange = () => {
    if (document.hidden || isPublicPath()) return;
    if (isSessionStale()) window.location.reload();
};

export const installSessionGuard = () => {
    sessionFingerprint = currentFingerprint();
    window.addEventListener('pagehide', handlePageHide);
    window.addEventListener('pageshow', handlePageShow);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
        window.removeEventListener('pagehide', handlePageHide);
        window.removeEventListener('pageshow', handlePageShow);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
};
